export enum SystemColumnType {
    AUTO_NUMBER = 'AUTO_NUMBER',
    CREATED_BY = 'CREATED_BY',
    CREATED_DATE = 'CREATED_DATE',
    MODIFIED_BY = 'MODIFIED_BY',
    MODIFIED_DATE = 'MODIFIED_DATE',
}
